module.exports = __webpack_public_path__ + "static/media/yu_hsuan_liao.19a3f59f.jpg";